"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.preview.title': '知识详情',
    'knowledge.preview.edit': '编辑',
    'knowledge.preview.back': '返回列表',
    'knowledge.preview.not_found': '未找到知识条目',
    'knowledge.preview.not_provided': '未提供',
    'knowledge.preview.no_tags': '无标签',
    'knowledge.preview.no_file': '无附件',
    'knowledge.preview.error.load_failed': '加载知识条目失败',
    'knowledge.preview.section.basic_info': '基本信息',
    'knowledge.preview.section.file_info': '文件信息',
    'knowledge.preview.section.content': '内容',
    'knowledge.preview.section.used_by_avatars': '被头像使用',
    'knowledge.preview.section.used_by_professions': '被职业使用',
    'knowledge.preview.section.errors': '错误',
    'knowledge.preview.content_type.text': '文本',
    'knowledge.preview.content_type.file': '文件',
    'knowledge.preview.content_type.link': '链接',
    'knowledge.preview.content_type.google-drive': 'Google Drive',
    'knowledge.preview.rag_status.pending': '待处理',
    'knowledge.preview.rag_status.processing': '处理中',
    'knowledge.preview.rag_status.completed': '已完成',
    'knowledge.preview.rag_status.failed': '失败',
    'knowledge.preview.rag_status.not_indexed': '未索引',
    'knowledge.preview.active.yes': '是',
    'knowledge.preview.active.no': '否',
    'knowledge.preview.no_avatars_using': '当前没有头像在使用此知识',
    'knowledge.preview.no_professions_using': '当前没有职业在使用此知识',
};
